<h2 class="mb-5" *ngIf="action == 'EDIT'">{{ 'PROCESSES.EDITPROCESS' | translate }}</h2>
<h2 class="mb-5" *ngIf="action == 'SHOW'">{{ 'PROCESSES.SHOWPROCESS' | translate }}</h2>

<div class="row mb-4">
  <div class="col-6">
    <div class="btn btn-primary backToProcessButton" (click)="utilsService.goBack();">
      <i class="fa fa-arrow-left" style="font-size: 15px;"></i> {{ ('COMMON.BACK' | translate).toUpperCase() }}
    </div>
  </div>
</div>

<form [formGroup]="detailProcessForm" (ngSubmit)="onSubmit()" id="detailProcessForm">
  <div class="row">
    <div class="col-6">
      <div class="card mb-4 border-0 shadow-sm">
        <div class="card-body mb-5">
          <div class="form-row">
            <div class="form-group col-12">
              <label for="office">{{ 'COMMON.OFFICE' | translate }}</label>
              <input type="office" class="form-control" id="office" formControlName="office">
              <small id="officeHelp" class="form-text text-muted" hidden>error</small>
            </div>
          </div>
          <label for="jobtype">{{ 'COMMON.JOBTYPE' | translate }}</label>
          <div class="form-row">
            <div class="form-group col-10">
              <select class="form-control" id="jobtype" formControlName="jobtype">
                <option [ngValue]="null">{{ 'INVITE.SELECTJOBTYPE' | translate }}</option>
                <option *ngFor="let jobtype of jobtypes$ | async" [ngValue]="jobtype.id">{{ jobtype.name |titlecase }}</option>
              </select>
            </div>
            <div class="col-2">
              <div class="form-group">
                <button class="idealProfileButton" [ngClass]="!jobtypeSelected ? 'disabled' : ''" [disabled]="!jobtypeSelected" type="button" [attr.title]="'competencias asociadas'" (click)="showModalViewSkills(jobtypeSelected)">
                  <i class="fa fa-eye text-blue" [ngbTooltip]="'TOOLTIP.COMPETENCES' | translate"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="card mb-4 border-0 shadow-sm">
        <div class="card-body">
          <div class="form-row">
            <div class="form-group col-12">
              <label for="name">{{ 'COMMON.NAME' | translate }}</label>
              <input type="name" class="form-control" id="name" formControlName="name" [attr.disabled]= "this.action=='SHOW'? true: null" >
              <ct-control-messages [control]="detailProcessForm.get('name')"></ct-control-messages>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <label for="description">{{ 'CONSULTANT.DESCRIPTION' | translate }}</label>
              <!-- <input type="description" class="form-control" id="description" formControlName="description"> -->
              <textarea type="description" class="form-control" id="description" formControlName="description" cols="30" rows="3" [attr.disabled]= "this.action=='SHOW'? true: null">
              </textarea>
              <ct-control-messages [control]="detailProcessForm.get('description')"></ct-control-messages>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="row" *ngIf="action == 'EDIT'">
  <button type="submit" form="detailProcessForm" class="btn btn-primary col-md-2 mx-auto" [disabled]="detailProcessForm.invalid">
    <i class="fa fa-save"></i> {{ 'COMMON.SAVE' | translate }}
  </button>
</div>

<ng-template #content let-modal>
  <div class="modal-header border-bottom-0">
    <h6 class="modal-title">{{ 'COMMON.SHOWCOMPETENCES' | translate }}</h6>
    <div id="closeModal">
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>&nbsp;
      </button>
    </div>
  </div>

  <div class="modal-body">
    <h5 class="font-weight-bold">Jobtype: {{jobtypeSelected.name}}</h5>
      <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th>{{'COMMON.AREA' | translate}}</th>
          <th>{{'COMMON.COMPETENCES' | translate}}</th>
        </tr>
      </thead>

      <tbody class="bg-white">
        <tr *ngFor="let questionGroup of jobtypeSelected.questionGroups; index as i">
          <td>{{ 'ADNREPORT.SKILLS.TYPES.' + questionGroup.type.toUpperCase() | translate }}</td>
          <td>{{ ('ADNREPORT.SKILLS.' + questionGroup.abbreviation + '.NAME') | translate }}</td>        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer justify-content-center">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel click')">{{ 'COMMON.CLOSE' | translate }}</button>
  </div>
</ng-template>
